/*!
 * NutUI v2.2.1 - cell.js, 59c3ac9b1672465eeb23, 2020-03-09T09:06:03+08:00
 * (c) 2017-2019 JDC
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cell", [], factory);
	else if(typeof exports === 'object')
		exports["cell"] = factory();
	else
		root["cell"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	function hotDisposeChunk(chunkId) {
/******/ 		delete installedChunks[chunkId];
/******/ 	}
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate_name_"];
/******/ 	this["webpackHotUpdate_name_"] = // eslint-disable-next-line no-unused-vars
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) {
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if (parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	} ;
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotDownloadUpdateChunk(chunkId) {
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		if (null) script.crossOrigin = null;
/******/ 		head.appendChild(script);
/******/ 	}
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotDownloadManifest(requestTimeout) {
/******/ 		requestTimeout = requestTimeout || 10000;
/******/ 		return new Promise(function(resolve, reject) {
/******/ 			if (typeof XMLHttpRequest === "undefined") {
/******/ 				return reject(new Error("No browser support"));
/******/ 			}
/******/ 			try {
/******/ 				var request = new XMLHttpRequest();
/******/ 				var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 				request.open("GET", requestPath, true);
/******/ 				request.timeout = requestTimeout;
/******/ 				request.send(null);
/******/ 			} catch (err) {
/******/ 				return reject(err);
/******/ 			}
/******/ 			request.onreadystatechange = function() {
/******/ 				if (request.readyState !== 4) return;
/******/ 				if (request.status === 0) {
/******/ 					// timeout
/******/ 					reject(
/******/ 						new Error("Manifest request to " + requestPath + " timed out.")
/******/ 					);
/******/ 				} else if (request.status === 404) {
/******/ 					// no update available
/******/ 					resolve();
/******/ 				} else if (request.status !== 200 && request.status !== 304) {
/******/ 					// other failure
/******/ 					reject(new Error("Manifest request to " + requestPath + " failed."));
/******/ 				} else {
/******/ 					// success
/******/ 					try {
/******/ 						var update = JSON.parse(request.responseText);
/******/ 					} catch (e) {
/******/ 						reject(e);
/******/ 						return;
/******/ 					}
/******/ 					resolve(update);
/******/ 				}
/******/ 			};
/******/ 		});
/******/ 	}
/******/
/******/ 	var hotApplyOnUpdate = true;
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	var hotCurrentHash = "59c3ac9b1672465eeb23";
/******/ 	var hotRequestTimeout = 10000;
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentChildModule;
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	var hotCurrentParents = [];
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	var hotCurrentParentsTemp = [];
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotCreateRequire(moduleId) {
/******/ 		var me = installedModules[moduleId];
/******/ 		if (!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if (me.hot.active) {
/******/ 				if (installedModules[request]) {
/******/ 					if (installedModules[request].parents.indexOf(moduleId) === -1) {
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					}
/******/ 				} else {
/******/ 					hotCurrentParents = [moduleId];
/******/ 					hotCurrentChildModule = request;
/******/ 				}
/******/ 				if (me.children.indexOf(request) === -1) {
/******/ 					me.children.push(request);
/******/ 				}
/******/ 			} else {
/******/ 				console.warn(
/******/ 					"[HMR] unexpected require(" +
/******/ 						request +
/******/ 						") from disposed module " +
/******/ 						moduleId
/******/ 				);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		var ObjectFactory = function ObjectFactory(name) {
/******/ 			return {
/******/ 				configurable: true,
/******/ 				enumerable: true,
/******/ 				get: function() {
/******/ 					return __webpack_require__[name];
/******/ 				},
/******/ 				set: function(value) {
/******/ 					__webpack_require__[name] = value;
/******/ 				}
/******/ 			};
/******/ 		};
/******/ 		for (var name in __webpack_require__) {
/******/ 			if (
/******/ 				Object.prototype.hasOwnProperty.call(__webpack_require__, name) &&
/******/ 				name !== "e" &&
/******/ 				name !== "t"
/******/ 			) {
/******/ 				Object.defineProperty(fn, name, ObjectFactory(name));
/******/ 			}
/******/ 		}
/******/ 		fn.e = function(chunkId) {
/******/ 			if (hotStatus === "ready") hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			return __webpack_require__.e(chunkId).then(finishChunkLoading, function(err) {
/******/ 				finishChunkLoading();
/******/ 				throw err;
/******/ 			});
/******/
/******/ 			function finishChunkLoading() {
/******/ 				hotChunksLoading--;
/******/ 				if (hotStatus === "prepare") {
/******/ 					if (!hotWaitingFilesMap[chunkId]) {
/******/ 						hotEnsureUpdateChunk(chunkId);
/******/ 					}
/******/ 					if (hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 						hotUpdateDownloaded();
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 		fn.t = function(value, mode) {
/******/ 			if (mode & 1) value = fn(value);
/******/ 			return __webpack_require__.t(value, mode & ~1);
/******/ 		};
/******/ 		return fn;
/******/ 	}
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotCreateModule(moduleId) {
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 			_main: hotCurrentChildModule !== moduleId,
/******/
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if (dep === undefined) hot._selfAccepted = true;
/******/ 				else if (typeof dep === "function") hot._selfAccepted = dep;
/******/ 				else if (typeof dep === "object")
/******/ 					for (var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback || function() {};
/******/ 				else hot._acceptedDependencies[dep] = callback || function() {};
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if (dep === undefined) hot._selfDeclined = true;
/******/ 				else if (typeof dep === "object")
/******/ 					for (var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 				else hot._declinedDependencies[dep] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if (idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if (!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if (idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		hotCurrentChildModule = undefined;
/******/ 		return hot;
/******/ 	}
/******/
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for (var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailableFilesMap = {};
/******/ 	var hotDeferred;
/******/
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = +id + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/
/******/ 	function hotCheck(apply) {
/******/ 		if (hotStatus !== "idle") {
/******/ 			throw new Error("check() is only allowed in idle status");
/******/ 		}
/******/ 		hotApplyOnUpdate = apply;
/******/ 		hotSetStatus("check");
/******/ 		return hotDownloadManifest(hotRequestTimeout).then(function(update) {
/******/ 			if (!update) {
/******/ 				hotSetStatus("idle");
/******/ 				return null;
/******/ 			}
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			hotAvailableFilesMap = update.c;
/******/ 			hotUpdateNewHash = update.h;
/******/
/******/ 			hotSetStatus("prepare");
/******/ 			var promise = new Promise(function(resolve, reject) {
/******/ 				hotDeferred = {
/******/ 					resolve: resolve,
/******/ 					reject: reject
/******/ 				};
/******/ 			});
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 7;
/******/ 			// eslint-disable-next-line no-lone-blocks
/******/ 			{
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if (
/******/ 				hotStatus === "prepare" &&
/******/ 				hotChunksLoading === 0 &&
/******/ 				hotWaitingFiles === 0
/******/ 			) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 			return promise;
/******/ 		});
/******/ 	}
/******/
/******/ 	// eslint-disable-next-line no-unused-vars
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) {
/******/ 		if (!hotAvailableFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for (var moduleId in moreModules) {
/******/ 			if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if (--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if (!hotAvailableFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var deferred = hotDeferred;
/******/ 		hotDeferred = null;
/******/ 		if (!deferred) return;
/******/ 		if (hotApplyOnUpdate) {
/******/ 			// Wrap deferred object in Promise to mark it as a well-handled Promise to
/******/ 			// avoid triggering uncaught exception warning in Chrome.
/******/ 			// See https://bugs.chromium.org/p/chromium/issues/detail?id=465666
/******/ 			Promise.resolve()
/******/ 				.then(function() {
/******/ 					return hotApply(hotApplyOnUpdate);
/******/ 				})
/******/ 				.then(
/******/ 					function(result) {
/******/ 						deferred.resolve(result);
/******/ 					},
/******/ 					function(err) {
/******/ 						deferred.reject(err);
/******/ 					}
/******/ 				);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for (var id in hotUpdate) {
/******/ 				if (Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			deferred.resolve(outdatedModules);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotApply(options) {
/******/ 		if (hotStatus !== "ready")
/******/ 			throw new Error("apply() is only allowed in ready status");
/******/ 		options = options || {};
/******/
/******/ 		var cb;
/******/ 		var i;
/******/ 		var j;
/******/ 		var module;
/******/ 		var moduleId;
/******/
/******/ 		function getAffectedStuff(updateModuleId) {
/******/ 			var outdatedModules = [updateModuleId];
/******/ 			var outdatedDependencies = {};
/******/
/******/ 			var queue = outdatedModules.slice().map(function(id) {
/******/ 				return {
/******/ 					chain: [id],
/******/ 					id: id
/******/ 				};
/******/ 			});
/******/ 			while (queue.length > 0) {
/******/ 				var queueItem = queue.pop();
/******/ 				var moduleId = queueItem.id;
/******/ 				var chain = queueItem.chain;
/******/ 				module = installedModules[moduleId];
/******/ 				if (!module || module.hot._selfAccepted) continue;
/******/ 				if (module.hot._selfDeclined) {
/******/ 					return {
/******/ 						type: "self-declined",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				if (module.hot._main) {
/******/ 					return {
/******/ 						type: "unaccepted",
/******/ 						chain: chain,
/******/ 						moduleId: moduleId
/******/ 					};
/******/ 				}
/******/ 				for (var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if (!parent) continue;
/******/ 					if (parent.hot._declinedDependencies[moduleId]) {
/******/ 						return {
/******/ 							type: "declined",
/******/ 							chain: chain.concat([parentId]),
/******/ 							moduleId: moduleId,
/******/ 							parentId: parentId
/******/ 						};
/******/ 					}
/******/ 					if (outdatedModules.indexOf(parentId) !== -1) continue;
/******/ 					if (parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if (!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push({
/******/ 						chain: chain.concat([parentId]),
/******/ 						id: parentId
/******/ 					});
/******/ 				}
/******/ 			}
/******/
/******/ 			return {
/******/ 				type: "accepted",
/******/ 				moduleId: updateModuleId,
/******/ 				outdatedModules: outdatedModules,
/******/ 				outdatedDependencies: outdatedDependencies
/******/ 			};
/******/ 		}
/******/
/******/ 		function addAllToSet(a, b) {
/******/ 			for (var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if (a.indexOf(item) === -1) a.push(item);
/******/ 			}
/******/ 		}
/******/
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/
/******/ 		var warnUnexpectedRequire = function warnUnexpectedRequire() {
/******/ 			console.warn(
/******/ 				"[HMR] unexpected require(" + result.moduleId + ") to disposed module"
/******/ 			);
/******/ 		};
/******/
/******/ 		for (var id in hotUpdate) {
/******/ 			if (Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				moduleId = toModuleId(id);
/******/ 				/** @type {TODO} */
/******/ 				var result;
/******/ 				if (hotUpdate[id]) {
/******/ 					result = getAffectedStuff(moduleId);
/******/ 				} else {
/******/ 					result = {
/******/ 						type: "disposed",
/******/ 						moduleId: id
/******/ 					};
/******/ 				}
/******/ 				/** @type {Error|false} */
/******/ 				var abortError = false;
/******/ 				var doApply = false;
/******/ 				var doDispose = false;
/******/ 				var chainInfo = "";
/******/ 				if (result.chain) {
/******/ 					chainInfo = "\nUpdate propagation: " + result.chain.join(" -> ");
/******/ 				}
/******/ 				switch (result.type) {
/******/ 					case "self-declined":
/******/ 						if (options.onDeclined) options.onDeclined(result);
/******/ 						if (!options.ignoreDeclined)
/******/ 							abortError = new Error(
/******/ 								"Aborted because of self decline: " +
/******/ 									result.moduleId +
/******/ 									chainInfo
/******/ 							);
/******/ 						break;
/******/ 					case "declined":
/******/ 						if (options.onDeclined) options.onDeclined(result);
/******/ 						if (!options.ignoreDeclined)
/******/ 							abortError = new Error(
/******/ 								"Aborted because of declined dependency: " +
/******/ 									result.moduleId +
/******/ 									" in " +
/******/ 									result.parentId +
/******/ 									chainInfo
/******/ 							);
/******/ 						break;
/******/ 					case "unaccepted":
/******/ 						if (options.onUnaccepted) options.onUnaccepted(result);
/******/ 						if (!options.ignoreUnaccepted)
/******/ 							abortError = new Error(
/******/ 								"Aborted because " + moduleId + " is not accepted" + chainInfo
/******/ 							);
/******/ 						break;
/******/ 					case "accepted":
/******/ 						if (options.onAccepted) options.onAccepted(result);
/******/ 						doApply = true;
/******/ 						break;
/******/ 					case "disposed":
/******/ 						if (options.onDisposed) options.onDisposed(result);
/******/ 						doDispose = true;
/******/ 						break;
/******/ 					default:
/******/ 						throw new Error("Unexception type " + result.type);
/******/ 				}
/******/ 				if (abortError) {
/******/ 					hotSetStatus("abort");
/******/ 					return Promise.reject(abortError);
/******/ 				}
/******/ 				if (doApply) {
/******/ 					appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 					addAllToSet(outdatedModules, result.outdatedModules);
/******/ 					for (moduleId in result.outdatedDependencies) {
/******/ 						if (
/******/ 							Object.prototype.hasOwnProperty.call(
/******/ 								result.outdatedDependencies,
/******/ 								moduleId
/******/ 							)
/******/ 						) {
/******/ 							if (!outdatedDependencies[moduleId])
/******/ 								outdatedDependencies[moduleId] = [];
/******/ 							addAllToSet(
/******/ 								outdatedDependencies[moduleId],
/******/ 								result.outdatedDependencies[moduleId]
/******/ 							);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 				if (doDispose) {
/******/ 					addAllToSet(outdatedModules, [result.moduleId]);
/******/ 					appliedUpdate[moduleId] = warnUnexpectedRequire;
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for (i = 0; i < outdatedModules.length; i++) {
/******/ 			moduleId = outdatedModules[i];
/******/ 			if (
/******/ 				installedModules[moduleId] &&
/******/ 				installedModules[moduleId].hot._selfAccepted
/******/ 			)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		Object.keys(hotAvailableFilesMap).forEach(function(chunkId) {
/******/ 			if (hotAvailableFilesMap[chunkId] === false) {
/******/ 				hotDisposeChunk(chunkId);
/******/ 			}
/******/ 		});
/******/
/******/ 		var idx;
/******/ 		var queue = outdatedModules.slice();
/******/ 		while (queue.length > 0) {
/******/ 			moduleId = queue.pop();
/******/ 			module = installedModules[moduleId];
/******/ 			if (!module) continue;
/******/
/******/ 			var data = {};
/******/
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for (j = 0; j < disposeHandlers.length; j++) {
/******/ 				cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/
/******/ 			// when disposing there is no need to call dispose handler
/******/ 			delete outdatedDependencies[moduleId];
/******/
/******/ 			// remove "parents" references from all children
/******/ 			for (j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if (!child) continue;
/******/ 				idx = child.parents.indexOf(moduleId);
/******/ 				if (idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// remove outdated dependency from module children
/******/ 		var dependency;
/******/ 		var moduleOutdatedDependencies;
/******/ 		for (moduleId in outdatedDependencies) {
/******/ 			if (
/******/ 				Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)
/******/ 			) {
/******/ 				module = installedModules[moduleId];
/******/ 				if (module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					for (j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 						dependency = moduleOutdatedDependencies[j];
/******/ 						idx = module.children.indexOf(dependency);
/******/ 						if (idx >= 0) module.children.splice(idx, 1);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/
/******/ 		// insert new code
/******/ 		for (moduleId in appliedUpdate) {
/******/ 			if (Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for (moduleId in outdatedDependencies) {
/******/ 			if (
/******/ 				Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)
/******/ 			) {
/******/ 				module = installedModules[moduleId];
/******/ 				if (module) {
/******/ 					moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 					var callbacks = [];
/******/ 					for (i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 						dependency = moduleOutdatedDependencies[i];
/******/ 						cb = module.hot._acceptedDependencies[dependency];
/******/ 						if (cb) {
/******/ 							if (callbacks.indexOf(cb) !== -1) continue;
/******/ 							callbacks.push(cb);
/******/ 						}
/******/ 					}
/******/ 					for (i = 0; i < callbacks.length; i++) {
/******/ 						cb = callbacks[i];
/******/ 						try {
/******/ 							cb(moduleOutdatedDependencies);
/******/ 						} catch (err) {
/******/ 							if (options.onErrored) {
/******/ 								options.onErrored({
/******/ 									type: "accept-errored",
/******/ 									moduleId: moduleId,
/******/ 									dependencyId: moduleOutdatedDependencies[i],
/******/ 									error: err
/******/ 								});
/******/ 							}
/******/ 							if (!options.ignoreErrored) {
/******/ 								if (!error) error = err;
/******/ 							}
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Load self accepted modules
/******/ 		for (i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch (err) {
/******/ 				if (typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch (err2) {
/******/ 						if (options.onErrored) {
/******/ 							options.onErrored({
/******/ 								type: "self-accept-error-handler-errored",
/******/ 								moduleId: moduleId,
/******/ 								error: err2,
/******/ 								originalError: err
/******/ 							});
/******/ 						}
/******/ 						if (!options.ignoreErrored) {
/******/ 							if (!error) error = err2;
/******/ 						}
/******/ 						if (!error) error = err;
/******/ 					}
/******/ 				} else {
/******/ 					if (options.onErrored) {
/******/ 						options.onErrored({
/******/ 							type: "self-accept-errored",
/******/ 							moduleId: moduleId,
/******/ 							error: err
/******/ 						});
/******/ 					}
/******/ 					if (!options.ignoreErrored) {
/******/ 						if (!error) error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if (error) {
/******/ 			hotSetStatus("fail");
/******/ 			return Promise.reject(error);
/******/ 		}
/******/
/******/ 		hotSetStatus("idle");
/******/ 		return new Promise(function(resolve) {
/******/ 			resolve(outdatedModules);
/******/ 		});
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {},
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: (hotCurrentParentsTemp = hotCurrentParents, hotCurrentParents = [], hotCurrentParentsTemp),
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./assets/";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire("./src/packages/cell/index.js")(__webpack_require__.s = "./src/packages/cell/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "./src/assets/svg sync recursive ^\\.\\/.*\\.svg$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./action.svg": "./src/assets/svg/action.svg",
	"./arrow-to-left.svg": "./src/assets/svg/arrow-to-left.svg",
	"./arrow-to-top.svg": "./src/assets/svg/arrow-to-top.svg",
	"./checked.svg": "./src/assets/svg/checked.svg",
	"./checked2.svg": "./src/assets/svg/checked2.svg",
	"./circle-cross.svg": "./src/assets/svg/circle-cross.svg",
	"./cross.svg": "./src/assets/svg/cross.svg",
	"./down.svg": "./src/assets/svg/down.svg",
	"./github.svg": "./src/assets/svg/github.svg",
	"./message.svg": "./src/assets/svg/message.svg",
	"./minus.svg": "./src/assets/svg/minus.svg",
	"./more.svg": "./src/assets/svg/more.svg",
	"./more2.svg": "./src/assets/svg/more2.svg",
	"./more3.svg": "./src/assets/svg/more3.svg",
	"./plus.svg": "./src/assets/svg/plus.svg",
	"./qrcode.svg": "./src/assets/svg/qrcode.svg",
	"./right.svg": "./src/assets/svg/right.svg",
	"./search.svg": "./src/assets/svg/search.svg",
	"./search2.svg": "./src/assets/svg/search2.svg",
	"./share.svg": "./src/assets/svg/share.svg",
	"./tick.svg": "./src/assets/svg/tick.svg",
	"./top.svg": "./src/assets/svg/top.svg",
	"./trolley.svg": "./src/assets/svg/trolley.svg",
	"./unchecked.svg": "./src/assets/svg/unchecked.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg sync recursive ^\\.\\/.*\\.svg$";

/***/ }),

/***/ "./src/assets/svg/action.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><g fill-rule=\"evenodd\"><path d=\"M.5 12c0 6.351 5.149 11.5 11.5 11.5S23.5 18.351 23.5 12 18.351.5 12 .5.5 5.649.5 12z\" stroke-opacity=\".6\" stroke=\"currentColor\" fill=\"#FFF\"/><path d=\"M10.909 4.364h2.182v2.182h-2.182zM10.909 8.727h2.182v10.909h-2.182z\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/arrow-to-left.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"19\" height=\"36\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.552 35.569a1.5 1.5 0 0 1-2.121-.017c-5.952-6.05-9.905-10.1-15.857-16.15a2 2 0 0 1 0-2.804c5.952-6.05 9.905-10.1 15.857-16.15a1.5 1.5 0 1 1 2.138 2.104C12.847 8.368 9.125 12.184 3.403 18c5.722 5.816 9.444 9.632 15.166 15.448a1.5 1.5 0 0 1-.017 2.121z\" fill=\"#2E2D2D\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./src/assets/svg/arrow-to-top.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 39\"><g fill-rule=\"evenodd\"><path d=\"M1.41 0C.63 0 0 .672 0 1.5S.63 3 1.41 3h28.18C30.37 3 31 2.328 31 1.5S30.369 0 29.59 0H1.41zM17 7.5a1.5 1.5 0 0 0-3 0v30a1.5 1.5 0 1 0 3 0v-30zM8.44 12.44l-8 8a1.5 1.5 0 1 0 2.12 2.12l8-8a1.5 1.5 0 1 0-2.12-2.12z\"/><path d=\"M16.56 6.44l14 14a1.5 1.5 0 1 1-2.12 2.12l-14-14a1.5 1.5 0 1 1 2.12-2.12z\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/checked.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 50\"><defs><path d=\"M38 19C38 8.507 29.493 0 19 0S0 8.507 0 19s8.507 19 19 19 19-8.507 19-19\" id=\"b\"/><filter x=\"-28.9%\" y=\"-18.4%\" width=\"157.9%\" height=\"157.9%\" filterUnits=\"objectBoundingBox\" id=\"a\"><feOffset dy=\"4\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/><feGaussianBlur stdDeviation=\"3\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/><feColorMatrix values=\"0 0 0 0 0.941176471 0 0 0 0 0.145098039 0 0 0 0 0.0588235294 0 0 0 0.15 0\" in=\"shadowBlurOuter1\"/></filter></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(6 2)\"><use fill=\"#000\" filter=\"url(#a)\" xlink:href=\"#b\"/><use fill=\"#F0250F\" xlink:href=\"#b\"/></g><path d=\"M16 31h20V11H16z\"/><path fill=\"#FFF\" d=\"M16 21l2.5-2.5 5 4.5 10-9.5L36 16 24 28h-1z\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/checked2.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 50\"><defs><path d=\"M19 0C8.506 0 0 8.506 0 19s8.506 19 19 19 19-8.506 19-19S29.494 0 19 0z\" id=\"b\"/><filter x=\"-28.9%\" y=\"-18.4%\" width=\"157.9%\" height=\"157.9%\" filterUnits=\"objectBoundingBox\" id=\"a\"><feOffset dy=\"4\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/><feGaussianBlur stdDeviation=\"3\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/><feComposite in=\"shadowBlurOuter1\" in2=\"SourceAlpha\" operator=\"out\" result=\"shadowBlurOuter1\"/><feColorMatrix values=\"0 0 0 0 0.941176471 0 0 0 0 0.145098039 0 0 0 0 0.0588235294 0 0 0 0.15 0\" in=\"shadowBlurOuter1\"/></filter></defs><g fill-rule=\"evenodd\"><g transform=\"translate(6 2)\"><use fill=\"#000\" filter=\"url(#a)\" xlink:href=\"#b\"/><path stroke=\"#F0250F\" stroke-width=\"3\" d=\"M19 1.5C9.335 1.5 1.5 9.335 1.5 19S9.335 36.5 19 36.5 36.5 28.665 36.5 19 28.665 1.5 19 1.5z\" stroke-linejoin=\"square\" fill=\"#FFF\"/></g><path d=\"M37 21c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12\" fill=\"#F0250F\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/circle-cross.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\"><path d=\"M30 15c0 8.285-6.716 15-15 15-8.284 0-15-6.715-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15zM10.56 8.44a1.501 1.501 0 0 0-2.12 2.121l4.439 4.44-4.44 4.438a1.5 1.5 0 0 0 2.121 2.122l4.44-4.44 4.44 4.44a1.501 1.501 0 0 0 2.12-2.122l-11-11zm11 2.12a1.5 1.5 0 0 0-2.12-2.121l-2 2a1.5 1.5 0 0 0 2.12 2.122l2-2z\" fill-rule=\"evenodd\" fill-opacity=\".6\"/></svg>"

/***/ }),

/***/ "./src/assets/svg/cross.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\"><g fill-rule=\"evenodd\"><path d=\"M.44 2.56A1.5 1.5 0 1 1 2.56.44l27 27a1.5 1.5 0 1 1-2.12 2.12L15 17.123 2.56 29.56A1.5 1.5 0 1 1 .44 27.44L12.878 15 .44 2.56zM27.44.44a1.5 1.5 0 1 1 2.12 2.12l-9 9a1.5 1.5 0 1 1-2.12-2.12l9-9z\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/down.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 11\"><path d=\"M15 7.757L27.737.21a1.5 1.5 0 0 1 1.53 2.58c-4.5 2.668-9 5.334-13.5 8a1.503 1.503 0 0 1-1.53 0c-4.5-2.666-9-5.332-13.5-8A1.5 1.5 0 1 1 2.266.21C6.51 2.726 10.756 5.24 15 7.757\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./src/assets/svg/github.svg":
/***/ (function(module, exports) {

module.exports = "<svg height=\"24\" class=\"octicon octicon-mark-github\" viewBox=\"0 0 16 16\" version=\"1.1\" width=\"24\" aria-hidden=\"true\"><path fill-rule=\"evenodd\" d=\"M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z\"></path></svg>"

/***/ }),

/***/ "./src/assets/svg/message.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"40\" height=\"40\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#2E2D2D\" fill-rule=\"evenodd\"><path d=\"M10 35.899c1.369-.79 2.743-1.58 4.111-2.371a1.377 1.377 0 0 1 1.136-.15l.021.006a18.57 18.57 0 0 0 7.865.348 18.198 18.198 0 0 0 4.757-1.507 17.286 17.286 0 0 0 2.912-1.763 16.288 16.288 0 0 0 2.467-2.282 15.604 15.604 0 0 0 1.874-2.649c.254-.455.485-.924.69-1.403A14.457 14.457 0 0 0 37 18.5a14.416 14.416 0 0 0-1.167-5.63 15.083 15.083 0 0 0-2.564-4.052 16.092 16.092 0 0 0-2.467-2.282 16.79 16.79 0 0 0-1.412-.954 17.746 17.746 0 0 0-4.655-1.968 18.577 18.577 0 0 0-9.467 0 18.085 18.085 0 0 0-3.155 1.159c-.512.246-1.013.515-1.5.809A16.774 16.774 0 0 0 7.901 7.62a15.883 15.883 0 0 0-2.184 2.487A15.346 15.346 0 0 0 4.17 12.87a14.413 14.413 0 0 0-.886 2.852A14.162 14.162 0 0 0 3 18.5c0 .932.101 1.862.284 2.776a14.455 14.455 0 0 0 1.212 3.56 1.5 1.5 0 1 1-2.691 1.324C-2.282 17.851.85 8.412 8.399 3.434c7.336-4.837 17.307-4.554 24.314.787 7.227 5.508 9.538 15.166 4.84 23.136-4.552 7.722-13.987 11.064-22.468 9.073l-5.829 3.367a1.5 1.5 0 0 1-2.249-1.299v-7C7.007 30.67 7.672 30 8.5 30c.828 0 1.5.67 1.5 1.498v4.401\"/><path d=\"M18.5 17h3a1.5 1.5 0 1 1 0 3h-3a1.5 1.5 0 1 1 0-3M31.5 17a1.5 1.5 0 1 1 0 3h-3a1.5 1.5 0 1 1 0-3h3M11.5 17a1.5 1.5 0 1 1 0 3h-3a1.5 1.5 0 1 1 0-3h3\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/minus.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 4\"><rect x=\"14\" y=\"20\" width=\"16\" height=\"4\" rx=\"2\" transform=\"translate(-14 -20)\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./src/assets/svg/more.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 9\"><g transform=\"translate(0 -13)\" fill-rule=\"evenodd\"><rect opacity=\".3\" y=\"15\" width=\"5\" height=\"5\" rx=\"2.5\"/><circle opacity=\".8\" cx=\"17.5\" cy=\"17.5\" r=\"4.5\"/><rect opacity=\".3\" x=\"30\" y=\"15\" width=\"5\" height=\"5\" rx=\"2.5\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/more2.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"37\" height=\"37\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#2E2D2D\" fill-rule=\"evenodd\"><path d=\"M34.414 29.914a2 2 0 0 0 0-2.828l-4.5-4.5a2 2 0 0 0-2.828 0l-4.5 4.5a2 2 0 0 0 0 2.828l4.5 4.5a2 2 0 0 0 2.828 0l4.5-4.5\" opacity=\".35\"/><path d=\"M34 13a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9zM33 0h-9a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zM14 13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9zM13 0H4a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zM14 33a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9zm-1-13H4a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-9a4 4 0 0 0-4-4zM33.707 29.207l-4.5 4.5a.999.999 0 0 1-1.414 0l-4.5-4.5a.999.999 0 0 1 0-1.414l4.5-4.5a.999.999 0 0 1 1.414 0l4.5 4.5a.999.999 0 0 1 0 1.414zm2.122-3.536l-4.5-4.5a4.002 4.002 0 0 0-5.658 0l-4.5 4.5a4.002 4.002 0 0 0 0 5.658l4.5 4.5a4.002 4.002 0 0 0 5.658 0l4.5-4.5a4.002 4.002 0 0 0 0-5.658z\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/more3.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"39\" height=\"7\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(-1 -17)\" fill=\"#2E2D2D\" fill-rule=\"evenodd\"><circle cx=\"36.5\" cy=\"20.5\" r=\"3.5\"/><circle cx=\"20.5\" cy=\"20.5\" r=\"3.5\"/><circle cx=\"4.5\" cy=\"20.5\" r=\"3.5\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/plus.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><rect y=\"6\" width=\"16\" height=\"4\" rx=\"2\"/><rect transform=\"rotate(90 8 8)\" y=\"6\" width=\"16\" height=\"4\" rx=\"2\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/qrcode.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"40\" height=\"39\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#2E2D2D\" fill-rule=\"evenodd\"><path d=\"M34 39a6 6 0 0 0 6-6v-3.5a1.5 1.5 0 1 0-3 0V33a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-3.5a1.5 1.5 0 1 0-3 0V33a6 6 0 0 0 6 6h28M38.5 18a1.5 1.5 0 1 1 0 3h-5a1.5 1.5 0 1 1 0-3h5M26.5 18a1.5 1.5 0 1 1 0 3h-25a1.5 1.5 0 1 1 0-3h25M40 6a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v3.5a1.5 1.5 0 1 0 3 0V6a3 3 0 0 1 3-3h28a3 3 0 0 1 3 3v3.5a1.5 1.5 0 1 0 3 0V6\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/right.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 30\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-11 0h30v30h-30z\"/><path d=\"M7.757 15C5.241 10.755 2.727 6.51.21 2.266A1.5 1.5 0 0 1 2.79.736l8 13.499c.28.472.28 1.058 0 1.53l-8 13.5a1.499 1.499 0 1 1-2.58-1.53L7.757 15z\" fill=\"currentColor\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/search.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 27\"><path d=\"M13.658 22.979c-5.511.363-10.273-3.81-10.637-9.321-.363-5.511 3.81-10.273 9.321-10.637 5.511-.363 10.273 3.81 10.637 9.321.363 5.511-3.81 10.273-9.321 10.637zM26.56 24.44l-3.369-3.37c4.277-5.4 3.599-13.197-1.545-17.778-5.144-4.581-12.968-4.355-17.838.516-4.871 4.87-5.097 12.694-.516 17.838 4.581 5.143 12.378 5.822 17.778 1.545l3.37 3.37a1.5 1.5 0 0 0 2.12-2.121z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./src/assets/svg/search2.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"40\" height=\"40\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#2E2D2D\" fill-rule=\"evenodd\"><path d=\"M24.495 34.027a1.5 1.5 0 0 1 1.03 2.818c-8.971 3.28-18.983-.611-23.385-9.088C-2.262 19.28.313 8.852 8.156 3.4 16-2.053 26.671-.834 33.083 6.246c6.412 7.08 6.571 17.82.371 25.087l6.107 6.107a1.501 1.501 0 0 1-2.122 2.121l-7.125-7.126a1.501 1.501 0 0 1 0-2.121c5.773-5.773 6.273-14.967 1.161-21.333-5.113-6.365-14.198-7.86-21.08-3.469-6.883 4.392-9.354 13.262-5.736 20.58 3.619 7.319 12.168 10.739 19.836 7.935\"/><path d=\"M27.272 15.453a1.5 1.5 0 0 0 2.757-1.182 12 12 0 0 0-6.299-6.299 1.5 1.5 0 0 0-1.182 2.757 9 9 0 0 1 4.821 4.959\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/share.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"40\" height=\"40\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#2E2D2D\" fill-rule=\"evenodd\"><path d=\"M31 40H6a6 6 0 0 1-6-6V11a6 6 0 0 1 6-6h9.5a1.5 1.5 0 0 1 0 3H6a3 3 0 0 0-3 3v23a3 3 0 0 0 3 3h25a3 3 0 0 0 3-3v-9.5a1.5 1.5 0 0 1 3 0V34a6 6 0 0 1-6 6\"/><path d=\"M39.435 5.313l-.024-.004a1.5 1.5 0 0 1 .15 2.252l-5 5a1.502 1.502 0 0 1-2.122 0 1.502 1.502 0 0 1 0-2.122l2.397-2.397C26.474 8.652 20 15.615 20 24v2.5a1.5 1.5 0 0 1-3 0V24c0-10.07 7.856-18.391 17.91-18.97-.824-.822-1.647-1.646-2.471-2.47a1.502 1.502 0 0 1 0-2.121 1.502 1.502 0 0 1 2.122 0l5 5\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/tick.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 21\"><path d=\"M10 13.5l-7-6-3 3L10.5 21 28 3.5l-3-3z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./src/assets/svg/top.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 33\"><g fill-rule=\"evenodd\"><path d=\"M17 1.5a1.5 1.5 0 0 0-3 0v30a1.5 1.5 0 1 0 3 0v-30zM8.44 6.44l-8 8a1.5 1.5 0 1 0 2.12 2.12l8-8a1.5 1.5 0 1 0-2.12-2.12z\"/><path d=\"M16.56.44l14 14a1.5 1.5 0 1 1-2.12 2.12l-14-14A1.5 1.5 0 1 1 16.56.44z\"/></g></svg>"

/***/ }),

/***/ "./src/assets/svg/trolley.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 39\"><path d=\"M3.63 5h22.363c5.789 0 9.278 4.972 8.312 10.342L32.6 24.037c-.56 3.69-4.112 5.893-7.9 5.893H5.27C4.513 29.93 4 29.274 4 28.52c0-.756.615-1.52 1.37-1.52H24.7c2.58 0 4.874-1.242 5.203-3.408l1.713-8.732C32.293 11.094 29.999 8 25.993 8H2.553C1.748 8 1.108 7.772.99 7.026L.017 1.581a1.367 1.367 0 1 1 2.699-.428L3.63 5zM3.5 16h12a1.5 1.5 0 0 1 1.5 1.5v.047a1.5 1.5 0 0 1-1.5 1.5h-12a1.5 1.5 0 0 1-1.5-1.5V17.5A1.5 1.5 0 0 1 3.5 16zM7 39a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm20 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./src/assets/svg/unchecked.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 50\"><defs><path d=\"M0 19c0 10.494 8.506 19 19 19s19-8.506 19-19S29.494 0 19 0 0 8.506 0 19z\" id=\"b\"/><filter x=\"-28.9%\" y=\"-18.4%\" width=\"157.9%\" height=\"157.9%\" filterUnits=\"objectBoundingBox\" id=\"a\"><feOffset dy=\"4\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/><feGaussianBlur stdDeviation=\"3\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/><feComposite in=\"shadowBlurOuter1\" in2=\"SourceAlpha\" operator=\"out\" result=\"shadowBlurOuter1\"/><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0\" in=\"shadowBlurOuter1\"/></filter></defs><g transform=\"translate(6 2)\" fill=\"none\" fill-rule=\"evenodd\"><use fill=\"#000\" filter=\"url(#a)\" xlink:href=\"#b\"/><path stroke-opacity=\".6\" stroke=\"#848484\" stroke-width=\"3\" d=\"M1.5 19c0 9.665 7.835 17.5 17.5 17.5S36.5 28.665 36.5 19 28.665 1.5 19 1.5 1.5 9.335 1.5 19z\" stroke-linejoin=\"square\" fill=\"#FFF\"/></g></svg>"

/***/ }),

/***/ "./src/packages/cell/cell.scss":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "./src/packages/cell/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/packages/cell/cell.vue?vue&type=template&id=61e59ced&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['nut-cell',{'nut-cell-link':_vm.isLink}],style:({'background-color':_vm.bgColor}),attrs:{"href":_vm.linkUrl,"target":_vm.target},on:{"click":_vm.jumpPage}},[_c('div',{staticClass:"nut-cell-box",on:{"click":_vm.clickCell}},[_vm._t("avatar"),_vm._v(" "),_c('div',{staticClass:"nut-cell-left"},[_c('span',{staticClass:"nut-cell-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('span',{staticClass:"nut-cell-sub-title"},[_vm._t("sub-title",[_vm._v(_vm._s(_vm.subTitle))])],2)]),_vm._v(" "),_c('div',{staticClass:"nut-cell-right"},[_c('span',{staticClass:"nut-cell-desc"},[_vm._t("desc",[_vm._v(_vm._s(_vm.desc))])],2),_vm._v(" "),_c('span',{staticClass:"nut-cell-icon"},[(_vm.showIcon)?_vm._t("icon",[_c('nut-icon',{attrs:{"type":"right","size":"15px","color":"#848484"}})]):_vm._e()],2)])],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/packages/cell/cell.vue?vue&type=template&id=61e59ced&

// EXTERNAL MODULE: ./src/packages/icon/icon.vue + 4 modules
var icon = __webpack_require__("./src/packages/icon/icon.vue");

// CONCATENATED MODULE: ./node_modules/happypack/loader.js?id=Babel!./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/packages/cell/cell.vue?vue&type=script&lang=js&
var cov_23akmzxwqk = function () {
  var path = "/Users/zhuzhida/Documents/JD_Project/nutui/src/packages/cell/cell.vue",
      hash = "78c43f248dcc500e4ffaaa9df8a966903455dea0",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/zhuzhida/Documents/JD_Project/nutui/src/packages/cell/cell.vue",
    statementMap: {
      "0": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 14
        }
      },
      "1": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 30
        }
      },
      "2": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 32
        }
      },
      "3": {
        start: {
          line: 78,
          column: 19
        },
        end: {
          line: 78,
          column: 32
        }
      },
      "4": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 32
        }
      }
    },
    fnMap: {},
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 32
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 32
          }
        }],
        line: 78
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {
      "0": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      sources: ["cell.vue"],
      names: [],
      mappings: ";;;;;;;;;;;;;;;;;;;;;;;;AAwBA;;AAEA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;;AAEA",
      file: "cell.vue",
      sourceRoot: "src/packages/cell",
      sourcesContent: ["<template>\n    <a :class=\"['nut-cell',{'nut-cell-link':isLink}]\" \n    :href=\"linkUrl\" \n    :style=\"{'background-color':bgColor}\"\n    :target=\"target\"\n    @click=\"jumpPage\">\n        <div class=\"nut-cell-box\" @click=\"clickCell\">\n            <slot name='avatar'></slot>\n            <div class=\"nut-cell-left\">\n                <span class=\"nut-cell-title\"><slot name=\"title\">{{title}}</slot></span>\n                <span class=\"nut-cell-sub-title\"><slot name=\"sub-title\">{{subTitle}}</slot></span>\n            </div>\n            <div class=\"nut-cell-right\">\n                <span class=\"nut-cell-desc\"><slot name=\"desc\">{{desc}}</slot></span>\n                <span class=\"nut-cell-icon\">\n                <slot name=\"icon\" v-if=\"showIcon\">\n                  <nut-icon type=\"right\" size=\"15px\" color=\"#848484\"></nut-icon>\n                </slot>\n                </span>\n            </div>\n        </div>\n    </a>\n</template>\n<script>\nimport Icon from '../icon/icon.vue';\n\nexport default {\n  name: \"nut-cell\",\n  props: {\n    title: {\n      type: String,\n      default: \"\"\n    },\n    subTitle: {\n      type: String,\n      default: \"\"\n    },\n    desc: {\n      type: String,\n      default: \"\"\n    },\n    isLink: {\n      type: Boolean,\n      default: false\n    },\n    linkUrl: {\n      type: String,\n      default: \"javascript:void(0)\"\n    },\n    showIcon: {\n      type: Boolean,\n      default: false\n    },\n    bgColor:{\n      type:String,\n      default:\"#fff\"\n    },\n    to:{\n      type:String,\n      default:\"\"\n    },\n    target:{\n      type:String,\n      default:\"_self\"\n    }\n  },\n  components:{\n    'nut-icon':Icon\n  },\n  data() {\n    return {};\n  },\n  methods:{\n    clickCell(){\n      this.$emit('click-cell')\n    },\n    jumpPage(){\n      if(!this.to) return false;\n      this.$router.push(this.to)\n    }\n  }\n\n};\n</script>"]
    },
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cellvue_type_script_lang_js_ = ({
  name: "nut-cell",
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    isLink: {
      type: Boolean,
      default: false
    },
    linkUrl: {
      type: String,
      default: "javascript:void(0)"
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: "#fff"
    },
    to: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: "_self"
    }
  },
  components: {
    'nut-icon': icon["a" /* default */]
  },
  data: function data() {
    cov_23akmzxwqk.s[0]++;
    return {};
  },
  methods: {
    clickCell: function clickCell() {
      cov_23akmzxwqk.s[1]++;
      this.$emit('click-cell');
    },
    jumpPage: function jumpPage() {
      cov_23akmzxwqk.s[2]++;

      if (!this.to) {
        cov_23akmzxwqk.b[0][0]++;
        cov_23akmzxwqk.s[3]++;
        return false;
      } else {
        cov_23akmzxwqk.b[0][1]++;
      }

      cov_23akmzxwqk.s[4]++;
      this.$router.push(this.to);
    }
  }
});
// CONCATENATED MODULE: ./src/packages/cell/cell.vue?vue&type=script&lang=js&
 /* harmony default export */ var cell_cellvue_type_script_lang_js_ = (cellvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

// CONCATENATED MODULE: ./src/packages/cell/cell.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  cell_cellvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cell.vue"
/* harmony default export */ var cell = (component.exports);
// EXTERNAL MODULE: ./src/packages/cell/cell.scss
var cell_cell = __webpack_require__("./src/packages/cell/cell.scss");

// CONCATENATED MODULE: ./src/packages/cell/index.js



cell.install = function (Vue) {
  Vue.component(cell.name, cell);
};

/* harmony default export */ var packages_cell = __webpack_exports__["default"] = (cell);

/***/ }),

/***/ "./src/packages/icon/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/packages/icon/icon.vue?vue&type=template&id=3879475e&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['nut-icon','nut-icon-'+_vm.type],style:({'height':_vm.size,'width':_vm.size,'color':_vm.color||''}),domProps:{"innerHTML":_vm._s(_vm.icon)}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/packages/icon/icon.vue?vue&type=template&id=3879475e&

// CONCATENATED MODULE: ./node_modules/happypack/loader.js?id=Babel!./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/packages/icon/icon.vue?vue&type=script&lang=js&
var cov_2qzxq91js2 = function () {
  var path = "/Users/zhuzhida/Documents/JD_Project/nutui/src/packages/icon/icon.vue",
      hash = "412d4caee2eb1131aa178b6c73b94129a5ae2d4e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/zhuzhida/Documents/JD_Project/nutui/src/packages/icon/icon.vue",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 12
        },
        end: {
          line: 6,
          column: 114
        }
      },
      "1": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "2": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 34,
          column: 7
        }
      },
      "3": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 66
        }
      },
      "4": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 66
        }
      }
    },
    fnMap: {},
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        }, {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        }],
        line: 30
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {
      "0": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      sources: ["icon.vue"],
      names: [],
      mappings: ";;;;;AAKA;;AAEA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;;AAEA;AACA",
      file: "icon.vue",
      sourceRoot: "src/packages/icon",
      sourcesContent: ["<template>\n    <i :class=\"['nut-icon','nut-icon-'+type]\" v-html=\"icon\" :style=\"{'height':size,'width':size,'color':color||''}\">\n    </i>\n</template>\n<script>\nconst types=['top','action','cross','down','right','more','plus','search','trolley','tick','minus','circle-cross'];\n\nexport default {\n  name: \"nut-icon\",\n  props: {\n    type: {\n      type: String,\n      default: ''\n    },\n    size: {\n      type: String,\n      default: ''\n    },\n    color: {\n      type: String,\n      default: '#2e2d2d'\n    }\n  },\n  data() {\n    return {\n      icon:null\n    };\n  },\n  created() {\n      if(types.indexOf(this.type)===-1){\n        console.error('nut-icon\u7EC4\u4EF6type\u503C('+this.type+')\u6709\u8BEF\uFF0C\u65E0\u6B64icon!');\n      }else{\n        this.icon = require('../../assets/svg/'+this.type+'.svg');\n      }\n  },\n  methods: {\n\n  }\n};\n</script>"]
    },
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

//
//
//
//
var types = (cov_2qzxq91js2.s[0]++, ['top', 'action', 'cross', 'down', 'right', 'more', 'plus', 'search', 'trolley', 'tick', 'minus', 'circle-cross']);
/* harmony default export */ var iconvue_type_script_lang_js_ = ({
  name: "nut-icon",
  props: {
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#2e2d2d'
    }
  },
  data: function data() {
    cov_2qzxq91js2.s[1]++;
    return {
      icon: null
    };
  },
  created: function created() {
    cov_2qzxq91js2.s[2]++;

    if (types.indexOf(this.type) === -1) {
      cov_2qzxq91js2.b[0][0]++;
      cov_2qzxq91js2.s[3]++;
      console.error('nut-icon组件type值(' + this.type + ')有误，无此icon!');
    } else {
      cov_2qzxq91js2.b[0][1]++;
      cov_2qzxq91js2.s[4]++;
      this.icon = __webpack_require__("./src/assets/svg sync recursive ^\\.\\/.*\\.svg$")("./" + this.type + '.svg');
    }
  },
  methods: {}
});
// CONCATENATED MODULE: ./src/packages/icon/icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var icon_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

// CONCATENATED MODULE: ./src/packages/icon/icon.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  icon_iconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "icon.vue"
/* harmony default export */ var icon = __webpack_exports__["a"] = (component.exports);

/***/ })

/******/ });
});
//# sourceMappingURL=cell.js.map